// @flow
import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import type { RecommendedScreenType } from 'types/common';
import Dotdotdot from 'react-dotdotdot';
import { CallToAction } from 'components/atoms/callToAction';
import { StringUtil } from 'utils/StringUtil';
import { RouteNames } from 'router';
import bedRoomIcon from 'assets/images/bedWhite.png';
import bathRoomIcon from 'assets/images/bathroomWhite.png';
import rupeeIcon from 'assets/images/rupee-icon-pink.png';
//eslint-disable-next-line
import styles from "./styles.scss";

type Props = {
  data: RecommendedScreenType,
  onClick: () => void,
  className?: string,
  isRestaurant?: boolean,
  isDefinedRoute: boolean,
};

const RecommendedCard = (props: Props) => {
  const {
    data,
    type,
    className,
    isRestaurant,
    isDefinedRoute,
    onClick,
  } = props;
  const [imageLoaded, setImageLoaded] = useState(false);

  const setOnload = () => {
    setImageLoaded(true);
  };
  if (!data) {
    return null;
  }
  const {
    information,
    project_list_description,
    listImageUrl,
    location,
    city,
    phoneNo,
    timings,
    currentStatus,
    isTodayClose,
    thumbNailUrl,
    project_name,
    bed,
    name,
    bath,
    price,
    postFix,
  } = data;
  const containerClass = classNames('card-list', className);
  const hideButton = props.location.pathname === RouteNames.workcations;
    return (
    <div className={containerClass} onClick={() => onClick(data)}>
      <img
        className={`list-image full`}
        onLoad={setOnload}
        style={
          thumbNailUrl && {
            animation: imageLoaded ? 'opacityAnimation 2000ms' : 'none',
          }
        }
        src={listImageUrl}
        alt={'recommended-image'}
      />
      {thumbNailUrl && (
        <img
          className={`list-image thumb`}
          src={thumbNailUrl}
          alt={'broken'}
          style={{
            visibility: imageLoaded ? 'hidden' : 'visible',
            position: 'absolute',
            left: '0',
            top: '0',
          }}
        />
      )}
      <div className={'recommended-info-card'}>
        <div>
          {
            props.type=='restaurant' || props.type=='projectDetails' ||  props.type=='career'  ? (
              <Dotdotdot clamp={2} tagName={'h1'}>
              {name }
           </Dotdotdot>
            ) :<Dotdotdot clamp={2} tagName={'h1'}>
            {project_name }
         </Dotdotdot>
          }
         
        </div>
        {type === 'rentals' && (
          <div>
            <p>{location}</p>
            <div className={'icon-container'}>
              <img className={'rupee-icon'} src={rupeeIcon} alt={''} />
              <h3>{`${price}${' '}${postFix}`}</h3>
            </div>
          </div>
        )}
        {type === 'homes' || type === 'projectDetails' ? (
          <Dotdotdot clamp={3} tagName={'p'}>
            {project_list_description}
          </Dotdotdot>
        ) : (
          <Dotdotdot clamp={3} tagName={'p'}>
            {type !== 'rentals' && StringUtil.sliceHtml(information)}
          </Dotdotdot>
        )}
        <CallToAction
          text={'Explore'}
          type={'link'}
          mode={'transparent'}
          size={'small'}
          // className={hideButton ? 'explore-btn-hidden' : 'explore-btn'}
          className={'explore-btn'}
          onClick={() => onClick(data)}
        />
      </div>
      <div
        className={
          type === 'rentals'
            ? 'recommended-address rentals'
            : 'recommended-address'
        }
      >
        {type === 'rentals' ? (
          <div className={'image-container'}>
            <div className={'bed-container'}>
              <img className={'bed-img'} src={bedRoomIcon} alt={'bed'} />
              <span className={'bed-count'}>{bed}&nbsp;Beds</span>
            </div>
            <div className={'bath-container'}>
              <img className={'bath-img'} src={bathRoomIcon} alt={'bath'} />
              <span className={'bath-count'}>{bath}&nbsp;Bath</span>
            </div>
          </div>
        ) : (
          <div>
            <p>{location}</p>
            {city && <p>{city}</p>}
            {phoneNo && <p>{phoneNo}</p>}
            {isRestaurant && isTodayClose && (
              <>
                <br />
                <p>CLOSED TODAY</p>
              </>
            )}
            {isRestaurant && !isTodayClose && (
              <>
                <br />
                <p>{currentStatus}</p>
                <p>{timings}</p>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default withRouter(RecommendedCard);
